import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/company/')({
  beforeLoad: () => {
    throw redirect({ to: '/company/dashboard' });
  },
});